// initial state
import axios from "axios";

const state = () => ({
    user: null,
    users: [],
    clients: [],
    transaction_types: [],
    expense_types: [],
    vat_rates: [],
    fixtures: [],
    cards: [],
    currencies: [],
    statuses: []
})

// getters
const getters = {}

// actions
const actions = {
    async getData({commit}, params) {
        console.log(params);
        axios.get(route('frontend.get_expenses_config', {fixture_id:params.fixture_id ?? null})).then(result => {
            commit('setUsers', result.data.users)
            commit('setClients', result.data.clients)
            commit('setTransactionTypes', result.data.transaction_types)
            commit('setExpenseTypes', result.data.expense_types)
            commit('setVATRates', result.data.vat_rates)
            commit('setUser', result.data.user)
            commit('setFixtures', result.data.fixtures)
            commit('setCards', result.data.cards)
            commit('setCurrencies', result.data.currencies)
            commit('setStatuses', result.data.statuses)
        });
    }
}

// mutations
const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setUsers(state, users) {
        state.users = users
    },
    setClients(state, clients) {
        state.clients = clients
    },
    setTransactionTypes(state, transaction_types) {
        state.transaction_types = transaction_types
    },
    setExpenseTypes(state, expense_types) {
        state.expense_types = expense_types
    },
    setVATRates(state, vat_rates) {
        state.vat_rates = vat_rates
    },
    setFixtures(state, fixtures) {
        state.fixtures = fixtures
    },
    setCards(state, cards) {
        state.cards = cards
    },
    setCurrencies(state, currencies) {
        state.currencies = currencies
    },
    setStatuses(state, statuses) {
        state.statuses = statuses
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}